import { ZoomController } from "../side-menu/components/SideMenuZoomController";

/**
 * Floating zoom pill pinned to the bottom-right of the editor canvas. Zoom just
 * toggles the --editor-scale CSS var (editor-independent). Undo/redo now live in
 * the top CanvasToolbar where they're more discoverable.
 */
export const CanvasControls = () => {
  return (
    <div
      className="bg-[var(--surface-50)]"
      style={{
        position: "absolute",
        bottom: "18px",
        right: "18px",
        zIndex: 12,
        display: "flex",
        alignItems: "center",
        gap: "8px",
        border: "1px solid var(--surface-border)",
        borderRadius: "11px",
        padding: "5px 6px",
        boxShadow: "0 2px 12px rgba(40,33,25,.14)",
      }}
    >
      <ZoomController />
    </div>
  );
};

export default CanvasControls;
